export class ProfilePhoto
{
    constructor
    (
        public contentType: string,
        public photo: string
    )    {}
}